<template>
  <v-sheet class="text-start">
    <page-head title="Branchs" :breadcrumb="['Shop', 'Branchs']">
      <template v-slot>
        <v-btn variant="outlined" color="primary" :to="{ name: 'branchCreate' }"
          ><v-icon>mdi-plus</v-icon>Create Branch</v-btn
        >
      </template>
    </page-head>
    <v-data-table-server
      :items="dataTable.items"
      :items-per-page="dataTable.itemsPerPage"
      :items-length="dataTable.totalItems"
      :headers="dataTable.headers"
      :loading="dataTable.isLoading"
      :items-per-page-options="dataTable.itemsPerPageOptions"
      @update:options="updateBranch"
    >
      <template v-slot:[`item.name`]="{ value, item }">
        <a :href="`/management/branch/id-${item.id}`">{{ value }}</a></template
      ></v-data-table-server
    >
  </v-sheet>
</template>

<script setup>
import PageHead from "@/components/admin_theme/PageHead.vue";
import { reactive } from "vue";
import { authAxios } from "@/util/Axios";
import { DEFAULT_DATATABLE } from "@/util/List";

const axios = authAxios();
const dataTable = reactive({
  headers: [{ title: "Name", key: "name", align: "start", sortable: false }],
  ...DEFAULT_DATATABLE,
});

function updateBranch({ page, itemsPerPage }) {
  dataTable.isLoading = true;
  loadBranch(page, itemsPerPage).then((response) => {
    dataTable.isLoading = false;
    dataTable.items = [...response.data.data];
    dataTable.totalItems = response.data.total_items;
  });
}

function loadBranch(page, length) {
  return axios({
    method: "GET",
    url: `${process.env.VUE_APP_BACKEND_URL}/api/shop_branch/vuetify`,
    params: { page: page, length: length, search: "" },
  });
}
</script>
